import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import type { MenuProps } from 'antd';
import { App } from 'antd';
import { DeleteOutlined, ExclamationCircleOutlined } from '@ant-design/icons';
import { routePaths } from 'router';
import { useDeleteCargo } from 'api/cargos/use-delete-cargo.ts';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { MoreActionsDropdown } from 'components/common/more-actions-dropdown';
import type { ICargoExtraActionsProps } from './types';

export const CargoExtraActionsComponent: React.FC<ICargoExtraActionsProps> = (props) => {
  const { cargoId } = props;
  const { t } = useTranslation();
  const { modal } = App.useApp();
  const navigate = useNavigate();
  const location = useLocation();
  const { mutateAsync: deleteCargo } = useDeleteCargo();

  const confirmDelete = () => {
    modal.confirm({
      title: t('common:confirm'),
      icon: <ExclamationCircleOutlined />,
      content: t('common:delete_confirm_text'),
      okText: t('common:delete'),
      cancelText: t('common:cancel'),
      onOk: async () => {
        await deleteCargo({ cargoId });
        if (location.key !== 'default') {
          navigate(-1);
        } else {
          navigate(routePaths.cargos);
        }
      },
    });
  };

  const handleDropdownClick: MenuProps['onClick'] = ({ key }) => {
    if (key === 'delete') {
      confirmDelete();
    }
  };

  return (
    <MoreActionsDropdown
      items={[
        {
          key: 'delete',
          label: t('common:delete'),
          icon: <DeleteOutlined />,
        },
      ]}
      onClick={handleDropdownClick}
    />
  );
};

export const CargoExtraActions = withRoleGuard(CargoExtraActionsComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.customer_manager,
]);
